import { FC, useContext } from 'react';

import { Button, H3, Link } from '@smartshell/ui-kit';

import { useWindowResize } from 'hooks';
import { LINKS } from 'links';
import { LocalizationContext } from 'localization';
import notification from 'services/notificationService';

import s from './DownloadShell.module.scss';

export const DownloadShell: FC = () => {
  const { t, lang } = useContext(LocalizationContext);
  const size = useWindowResize();
  return (
    <div className={s.container}>
      <div className={s.top}>
        <div className={s.text_block}>
          <H3>{t('settings.shell.download.title')}</H3>
          <span className={s.text}>
            {t('settings.shell.download.description')}
          </span>
        </div>
        <Button
          iconName={size.width > 960 ? 'IncomeIcon' : 'CopyIcon'}
          className={s.button}
          onClick={() => {
            if (
              process.env.NODE_ENV === 'production' &&
              process.env.REACT_APP_YANDEX_ID
            ) {
              window.ym?.(
                Number(process.env.REACT_APP_YANDEX_ID),
                'reachGoal',
                'shell_download'
              );
              window.dataLayer?.push({ event: 'shell_download' });
            }

            if (size.width > 960) {
              window.open(
                'https://dl.smartshell.gg/ShellSetup.exe',
                '_blank',
                'noreferrer'
              );
            } else {
              navigator?.clipboard
                ?.writeText('https://dl.smartshell.gg/ShellSetup.exe')
                .then(() => {
                  notification.info({
                    t,
                    type: 'success',
                    title: t('header.shell.copied'),
                    dismiss: 5,
                  });
                })
                .catch(() => {
                  notification.info({
                    t,
                    type: 'error',
                    title: t('header.shell.copied.error'),
                    dismiss: 5,
                  });
                });
            }
          }}
        >
          {size.width > 960
            ? t('settings.shell.download.button')
            : t('link.copy')}
        </Button>
      </div>
      <Link title={t('more')} link={LINKS.shell_download[lang]} />
    </div>
  );
};
